import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorComponent } from '@abp/ng.theme.basic';
import { CoreModule } from '@abp/ng.core';

@Component({
  selector: 'dw-core-error',
  standalone: true,
  imports: [CommonModule, CoreModule],
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent extends ValidationErrorComponent {}
